<template>
  <div class="h-100" style="background-color: white; padding: 0dvb;">
    <Loader v-if="loading && (fromJd || fromContact || aiMode)" />
    <template v-if="!loading && !errors.length && applicant">
      <div class="profile-container">
        <!-- Sticky Header -->
        <div class="prof-header-fixed">
          <div
            class="prof-head-right d-flex align-items-center mb-0 w-100"
            v-if="!hideHeaderRight"
          >
            <div class="d-flex align-items-center gap-10">
              <Favorite
                :favorite="applicant.isFavorite"
                :toggledisabled="operationLoading"
                @click.native="toggleFavorite(applicant)"
              />
              <span v-if="favoriteActionError" class="favorite-action-error">{{ favoriteActionError }}</span>
              <Memo :applicant="applicant" class="memoClass" />
              <StatusDropDown
                :applicant="applicant"
                :isPreview="isPreview"
                :class="colorClass"
                @hidden="$emit('hidden')"
                @shown="$emit('shown')"
                @statusChanged="statusChanged"
                :toggledisabledstatus="loading"
              />
              <ReviewListDropdown
                v-if="isReviewer"
                :applicant="applicant"
                :isPreview="isPreview"
                @statusChanged="statusChanged"
                :toggledisabledstatus="loading"
              />
            </div>
            
            <div class="ms-auto d-flex align-items-center gap-15">
              <div
                class="favorite-wrapper mt-1"
                v-show="isReviewer && !hideDownloadPdf"
              >
                <a
                  href="Javascript:void(0);"
                  v-on:click="downloadPdf"
                  title="Download PDF"
                  class="icon-link"
                >
                  <img
                    src="@/assets/images/newPdf.png"
                    alt="履歴書PDF"
                    style="width: 27px; height: 30px;"
                  />
                </a>
                <span class="icon-label mt-1 ms-1">PDF</span>
              </div>
              <div class="favorite-wrapper mt-1" v-if="isReviewer">
                <Interview
                  :interview="applicant.isInterview"
                  :toggledisabledInt="operationLoading"
                  @click.native="toggleInterview(applicant)"
                  class="icon-component"
                />
                <span class="icon-label">面接</span>
              </div>
              <div class="favorite-wrapper" v-if="!hideMailIcon && isReviewer">
                <a
                  href="javascript:void(0);"
                  title="送受信"
                  @click="$emit('open-contact')"
                >
                  <img
                    src="@/assets/images/mail.png"
                    alt="送受信"
                    style="width: 32px; height: 23px;"
                  />
                </a>
                <span class="icon-label me-2">送受信</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Scrollable content area -->
        <div class="prof-body-scrollable">
          <basic-info 
            :profile="basicInfo" 
            :highlights="highlights"
            :showNavigation="showNavigation"
            :canGoPrevious="canGoPrevious"
            :canGoNext="canGoNext"
            @previous="handlePrevious"
            @next="handleNext"
          />
          <div class="profile-content">
            <employment-info
              :history="employmentHistory"
              :applicant="applicant"
              :eventHistory="eventHistory"
              :resumeLoading="resumeLoading"
              @previewClick="previewResume"
              :highlights="highlights"
            />
          </div>
        </div>
      </div>
      <!-- <div
        v-if="fromContact"
        style="border-top: 1px solid #3c3c3c; padding: 10px; position: relative"
      >
        <h3>スカウトする求人</h3>
        <div
          v-if="jdInfoDisplay && applicantJd"
          class="popup-box"
          ref="popupBox"
        >
          <div
            class="d-flex align-items-start justify-content-between"
            gap: 14px;
            style="padding: 10px;"
          >
            <p>{{ applicantJd.jd_info.job_title }}</p>
            <button
              class="close-btn"
              @click="
                jdInfoDisplay = false;
                scrollToTop();
              "
            >
              ×
            </button>
          </div>
          <div
            v-html="applicantJd.jd_info.job_description"
            class="mt-4"
            style="max-height: 480px; overflow:auto; padding: 10px;"
          ></div>
        </div>
        <h4
          v-if="applicantJd"
          @click="toggleJdInfoDisplay"
          style="cursor: pointer; color: #2F80ED;font-size: 18px;"
        >
          {{ applicantJd.jd_info.job_title }}
        </h4>

        <p v-if="applicantJd">
          {{ formatDate(applicantJd.created_at) }}
          {{
            applicantJd &&
              applicantJd.assigned_by &&
              applicantJd.assigned_by.full_name
          }}
        </p>
      </div> -->
    </template>
  </div>
</template>

<script>
import Favorite from '../Favorite.vue';
import Interview from '../Interview.vue';
import Memo from '../Memo.vue';
import StatusDropDown from '../../StatusDropDown.vue';
import ReviewListDropdown from '../../ReviewListDropdown.vue';
import CompanyFrom from '../CompanyFrom.vue';
import EventParticipation from '../EventParticipation.vue';
import Loader from '@/components/utils/Loader.vue';
// import AcademicInfo from '../profile/AcademicInfo.vue';
import BasicInfo from '../profile/BasicInfo.vue';
import EmploymentInfo from '../profile/EmploymentInfo.vue';
import Api from '../../../../config/api';
import ApiService from '../../../../service/apiService';
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex';
import mutations from '@/config/mutations';
import moment from 'moment';

export default {
  name: 'Profile',
  props: [
    'applicantId',
    'applicantIndex',
    'hideHeaderRight',
    'hideNewTab',
    'isAdmin',
    'isPreview',
    'isReviewer',
    'hideDownloadPdf',
    'hideMailIcon',
    'isMaxHeight',
    'fromContact',
    'fromJd',
    'canGoPrevious',
    'canGoNext',
    'showNavigation',
    'aiMode',
  ],
  components: {
    // AcademicInfo,
    EmploymentInfo,
    ReviewListDropdown,
    Memo,
    StatusDropDown,
    BasicInfo,
    Favorite,
    Interview,
    CompanyFrom,
    EventParticipation,
    Loader,
  },
  data() {
    return {
      // applicant: null,
      errors: [],
      loading: true,
      printer_off: true,
      resumeLoading: false,
      matchedJd: null,
      highlights: [],
      jdInfoDisplay: false,
      applicantJd: null,
      operationLoading: false,
      favoriteActionError: '',
    };
  },
  computed: {
    ...mapGetters({
      statusColorMap: 'getStatusColorMap',
      companyContactAuthority: 'getCompanyContactAuthority',
      userContactAuthority: 'getUserContactAuthority',
      getApplicantReadStatus: 'getApplicantReadStatus',
      aiJobSeeker: 'getAiJobSeeker',
      aiProfileLoading: 'getAiProfileLoading',
    }),
    ...mapState({
      applicantProfile: (state) => state.applicant.profile,
    }),
    // AiJdPanel.vue already fetches this same jobseeker (via loadProfileWithAiJds,
    // keyed to remount on every id change) for the JD panel on the right — reusing
    // it here instead of this component's own loadProfile() avoids firing the same
    // heavy populate-chain query twice per navigation, which is what was making
    // "next/previous" feel stuck in AI Matching.
    applicant() {
      return this.aiMode ? this.aiJobSeeker : this.applicantProfile;
    },
    computedStyle() {
      if (!this.isMaxHeight) {
        return 'max-height: 80vh;overflow:auto';
      } else {
        return '';
      }
    },
    hasIndividualContactAuthority() {
      return this.companyContactAuthority && this.userContactAuthority;
    },
    companyFrom() {
      return this.applicant.companyFrom;
    },
    basicInfo() {
      const companyFrom = this.companyFrom;
      const {
        name,
        gender,
        last_name,
        birthDate,
        email,
        phone,
        residence,
        employment,
        furigana,
        last_furigana,
        age,
        education,
        status,
        new_status,
        events,
      } = this.applicant;
      return {
        name,
        gender,
        last_name,
        birthDate,
        email,
        phone,
        residence,
        position: employment.position || '',
        furigana: furigana || 'N/A',
        last_furigana,
        age,
        education,
        companyFrom,
        status,
        events,
        new_status,
      };
    },
    colorClass() {
      const status = this.applicant.new_status || this.applicant.status;
      // Return status-based class name for new color system
      if (status && this.statusColorMap[status]) {
        return `status-${status}`;
      }
      return '';
    },
    // academicInfo() {
    //   return this.applicant.education;
    // },
    employmentHistory() {
      return this.applicant.employment;
    },
    eventHistory() {
      return this.applicant.events;
    },
    shouldScroll() {
      return !(this.applicantJd && this.fromContact);
    },

  },
  methods: {
    ...mapMutations({
      mutateApplicantsAfterFav: 'mutateApplicantsAfterFav',
      mutateApplicantsAfterInterview: 'mutateApplicantsAfterInterview',
      setProfile: mutations.applicant.SET_PROFILE,
      setApplicantStatus: 'setApplicantStatus',
      setProfileView: 'setProfileView',
      clearJDDatas: 'clearJDDatas',
      clearProfileJDDatas: 'profileJd/clearProfileJDDatas',
      setProfileLoaded: 'setProfileLoaded',
      clearAllJds: 'jd/clearAllJds',
      setJdForContact: 'setJdForContact',
      setApplicantFavorite: 'setApplicantFavorite',
      setApplicantInterview: 'setApplicantInterview',
      setApplicantJD: 'setApplicantJD',
    }),
    ...mapActions({
      highlightProfileInfo: 'highlightProfileInfo',
      setReadStatus: 'setReadStatus',
    }),
    toggleJdInfoDisplay() {
      this.jdInfoDisplay = !this.jdInfoDisplay;
      if (this.jdInfoDisplay) {
        this.$nextTick(() => {
          const heading = this.$el.querySelector('h3');
          if (heading) {
            heading.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    highlightText(paths, originalText) {
      if (!this.highlights || !this.highlights.length) {
        return originalText;
      }

      const highlights = this.highlights.filter((h) => paths.includes(h.path));
      if (highlights.length === 0) {
        return originalText;
      }

      let highlightedText = originalText;

      for (let highlight of highlights) {
        let reconstructedText = '';
        for (let textPart of highlight.texts) {
          if (textPart.type === 'hit') {
            reconstructedText += `<mark>${textPart.value}</mark>`;
          } else {
            reconstructedText += textPart.value;
          }
        }

        if (
          highlightedText.includes(highlight.texts.map((t) => t.value).join(''))
        ) {
          highlightedText = highlightedText.replace(
            highlight.texts.map((t) => t.value).join(''),
            reconstructedText
          );
        }
      }

      return highlightedText;
    },
    toggleFavorite(applicant) {
      this.operationLoading = true;
      this.favoriteActionError = '';
      const method = applicant.isFavorite ? 'delete' : 'put';
      ApiService[method](Api.endpoints.FAVORITE(applicant.id))
        .then(({ data }) => {
          // this.applicant = data.data;
          this.setApplicantFavorite(data.data.isFavorite);
          this.mutateApplicantsAfterFav(data.data);
          // this.$emit('toggled', this.applicant);
        })
        .catch(({ response }) => this.parseFavoriteError(response))
        .then(() => {
          this.operationLoading = false;
        });
    },
    // A 404 here means "this applicant can't be favorited right now" (e.g. an
    // AI-matched candidate), not "bad route" — the shared parseErrorResponse
    // mixin treats every 404 as a dead route and navigates the whole app to
    // /404. Pushing into `errors` would be just as bad here: the template
    // gates its ENTIRE render on `!errors.length` (see line 4), so that would
    // blank this whole profile panel over a failed button click. Show it
    // inline next to the button instead — nothing else should be affected.
    parseFavoriteError(response) {
      if (response && response.status === 404) {
        const message = response.data && response.data.data && response.data.data.error;
        this.favoriteActionError = message || 'お気に入りの更新に失敗しました。';
        return;
      }
      this.parseErrorResponse(response);
    },
    toggleInterview(applicant) {
      this.operationLoading = true;
      const method = applicant.isInterview ? 'delete' : 'put';
      ApiService[method](Api.endpoints.INTERVIEW(applicant.id))
        .then(({ data }) => {
          // this.applicant = data.data;
          this.setApplicantInterview(data.data.isInterview);
          // this.mutateApplicantsAfterInterview(data.data);
          // this.$emit('toggled', this.applicant);
        })
        .catch(({ response }) => this.parseErrorResponse(response))
        .then(() => {
          this.operationLoading = false;
        });
    },
    loadProfile() {
      this.loading = true;
      ApiService.get(Api.endpoints.APPLICANT_PROFILE(this.applicantId))
        .then(({ data }) => {
          // this.applicant = data.data.applicant;
          this.setProfile(data.data.applicant);
          let applicantJd = data.data.applicantJd
            ? data.data.applicantJd.jd_info
            : null;

          if (this.fromContact && applicantJd) {
            // console.log(applicantJd);
            this.applicantJd = data.data.applicantJd;
          }
          if (this.fromJd && applicantJd) {
            this.setApplicantJD(data.data.applicantJd);
          }
          this.setProfileLoaded(true);
          this.setJdForContact(data.data.applicantJd);
          // this.setApplicantJd(applicantJd);
          // this.setIndividualJd(applicantJd);

          if (applicantJd) {
            this.setProfileView({
              view: 'jdInfo',
              applicantJD: applicantJd,
              individualJD: applicantJd,
              userBasedMatching: false,
            });
          } else {
            this.setProfileView({ view: 'jdList', userBasedMatching: false });
          }
          // if (this.getApplicantReadStatus(this.applicantId) !== 'read') {
          //   this.setReadStatus(this.applicantId);
          // }
        })
        .catch(({ response }) => this.parseErrorResponse(response))
        .then(() => {
          this.loading = false;
          this.$emit('profileLoaded', true);
        });
    },
    downloadPdf() {
      // this.viewPdf();
      ApiService.get(Api.endpoints.PDFDOWNLOAD(this.applicantId))
        .then((response) => {
          const buff = Buffer.from(response.data.data.data);
          const blobData = new Blob([buff]);
          // this.downloadFile(blobData);
          const url = window.URL.createObjectURL(blobData);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `CV ${this.makeid()}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(({ response }) => this.parseErrorResponse(response))
        .then(() => {
          this.loading = false;
        });
    },
    makeid() {
      let text = '';
      const possible =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < 10; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },
    viewPdf() {
      ApiService.get(Api.endpoints.PDFDOWNLOAD(this.applicantId))
        .then((response) => {
          const buff = Buffer.from(response.data.data.data);
          // const blobData = new Blob([buff]);
          const file = new Blob([buff], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          const win = window.open(fileURL, '_blank');
          win.focus();
          win.print();
          // this.print();
        })
        .catch(({ response }) => this.parseErrorResponse(response))
        .then(() => {
          this.loading = false;
        });
    },
    previewResume(type) {
      (this.resumeLoading = true),
        ApiService.get(Api.endpoints.PREVIEW(this.applicantId, type))
          .then((response) => {
            const data = response.data;
            const win = window.open(data.signedUrl, '_blank');
            win.focus();
          })
          .catch(({ response }) => this.parseErrorResponse(response))
          .then(() => {
            this.loading = false;
            this.resumeLoading = false;
          });
    },
    statusChanged(data) {
      // data contains the full applicant object from API response
      // Pass the full object to the mutation which will handle both fields
      this.setApplicantStatus(data);
    },
    // Method to expose loading state to parent component
    getLoadingState() {
      return this.loading;
    },
    handlePrevious() {
      this.$emit('previous');
    },
    handleNext() {
      this.$emit('next');
    },
  },
  watch: {
    async applicantId() {
      if (this.aiMode) return; // AiJdPanel's own :key="id" remount handles the fetch
      this.loadProfile();
      if (!this.fromJd) this.clearAllJds();
      const highlights = await this.highlightProfileInfo(this.applicantId);
      this.highlights = highlights;
    },
    applicant(val) {
      if (this.aiMode) return; // aiJobSeeker is null between navigations by design
      if (!val && this.applicantId && !this.loading) {
        this.loadProfile();
      }
    },
    aiProfileLoading(val) {
      if (this.aiMode) this.loading = val;
    },
  },
  async mounted() {
    if (this.aiMode) {
      this.loading = this.aiProfileLoading;
      return;
    }
    this.loadProfile();
    const highlights = await this.highlightProfileInfo(this.applicantId);
    this.highlights = highlights;
  },
  beforeDestroy() {
    this.clearJDDatas(null);
    this.setProfile(null);
    this.clearProfileJDDatas();
    if (!this.fromJd) this.clearAllJds();
  },
};
</script>

<style scoped>
h3 {
  font-size: 24px;
}
.favorite-action-error {
  color: #d9534f;
  font-size: 12px;
  white-space: nowrap;
}
.h-100 {
  height: 100%;
}
.status-box {
  width: 135px;
  border: 1px solid #b3b3b3;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #d9d9d9;
  color: #000000;
  font-size: 15px;
  font-weight: bold;
}
.scrollable-content {
  overflow: hidden auto;
  max-height: calc(82vh - 380px); /* Adjust this value based on your layout */
}

.jd-section {
  border-top: 1px solid #3c3c3c;
  padding: 10px;
  position: relative;
  flex-shrink: 0; /* Prevents the JD section from shrinking */
}

.popup-box div[style*='overflow:auto'] {
  will-change: transform;
  transform: translateZ(0);
}

.jd-container {
  position: relative;
}

.popup-box {
  position: absolute;
  top: 90%;
  left: 0;
  width: 100%;
  background-color: #f2f5f7;
  z-index: 10;
  /* padding: 16px; */
  border: 1px solid #ccc;
  border-radius: 1px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
}

.close-btn {
  /* position: absolute;
  top: 5px;
  right: 12px; */
  background: transparent;
  border: none;
  font-size: 30px;
  cursor: pointer;
}

.highlight {
  background-color: yellow;
}
/deep/ mark {
  background-color: yellow;
  padding: 0px;
}
.margin-bottom-0 {
  margin-bottom: 0px !important;
}
/*CSS form other Scss*/
.favorite-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50px;
}

.icon-label {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  margin-top: 2px;
  text-align: center;
  line-height: 1.5;
  white-space: nowrap;
  height: 30px;
  width: 30px;
}

.prof-header-fixed {
  /* padding: 10px 15px; */
  padding: 0px 15px 0px 15px;
  /* border-bottom: 1px solid #eee; */
  flex-shrink: 0;
  background-color: #F7FFF4;
  z-index: 10;
}

.prof-body-scrollable {
  flex: 1;
  overflow-y: auto;
  padding: 0 15px 15px 15px;
}

.profile-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.gap-10 {
  gap: 5px;
}

.gap-15 {
  gap: 5px;
}

.icon-link, .icon-component {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  margin-bottom: 2px;
}
/deep/ .profile-info-block table th,
/deep/ .profile-info-block table td {
  border: none !important;
  padding-top: 2px;
  padding-bottom: 2px;
}

/deep/ table th,
/deep/ table td {
  border: none !important;
  vertical-align: middle;
}

/deep/ table th {
  color: #3c3c3c;
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
  border: none !important;
  padding: 5px 0 5px 0;
}

/deep/ table td {
  border: none !important;
  border-bottom: solid 1px #d9e6ed !important;
  font-size: 12px;
  white-space: normal !important;
  word-break: break-word;
  min-width: 80px;
  color: #617776;
  padding: 5px 7px !important;
}

/deep/ table td .btn-heart i,
/deep/ table td .btn-heart-fill i {
  font-size: 20px;
}

/deep/ table td a {
  font-size: 12px;
  color: #617776;
}

/deep/ table th:last-child,
/deep/ table td:last-child {
  padding-right: 0;
  min-width: 25px !important;
}

/deep/ table tr:last-child td {
  border: none !important;
}

/deep/ table p {
  margin: 0;
}

/deep/ td.td-date {
  font-size: 12px;
  color: #617776;
}

/deep/ td.td-status {
  color: #617776;
  font-size: 12px;
}

/deep/ .modal-body {
  padding-top: 3px;
  padding-bottom: 4px;
}

/deep/ table td.no-wrap {
  white-space: nowrap !important;
}

/deep/ .table-responsive {
  margin-bottom: 0;
}
</style>

<style scoped>
.yellow button {
  color: #000;
  background-color: #ffea00;
  border-color: #ffea00;
}
.yellow button:hover,
.show.yellow button {
  background-color: white !important;
  color: black !important;
  border-color: #ffea00 !important;
}
.prof-head-right a {
  display: inline-block;
  margin-left: 5px;
  /* font-size: 15px; */
  color: #212529;
  font-size: 25px;
  /* color: #dbdbdb; */
}

.prof-head-right {
  margin-bottom: -4px;
  margin-left: -10px;
  gap: 5px;
  height: 73px;
  max-height: 73px;
}

.prof-head-left {
  display: flex;
}

.prof-head-right i {
  font-size: 30px;
  color: #dbdbdb;
}

.prof-head-right a:hover i {
  color: #aba2a2;
}

.profile-info-block th {
  width: 130px;
}

.btn-arw {
  color: #dbdbdb;
  min-width: 30px;
}

.btn-arw:hover,
.btn-arw:focus {
  color: #aba2a2;
}

.btn-arw [disabled] {
  cursor: not-allowed;
}

/* .memoClass {
  margin-top: 5px;
} */

.font-27 {
  font-size: 27px !important;
}
</style>
